
import { SelectionModel } from '@angular/cdk/collections';
import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { Configuration } from 'src/app/domain/configuration';
import { EComparaisonLQ } from 'src/app/domain/enum/comparaison-lq';
import { ELimitValueType } from 'src/app/domain/enum/limit-value-type';
import { Limit } from 'src/app/domain/limit';
import { LimitCategory } from 'src/app/domain/limit-category';
import { ProductGroup } from 'src/app/domain/product-group';
import { Test } from 'src/app/domain/test';
import { TestGroup } from 'src/app/domain/test-group';
import { ENavigationRoute } from 'src/app/model/enum/navigation-route';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { LimitService } from 'src/app/services/limit.service';
import { ProductGroupService } from 'src/app/services/product-group.service';
import { TestGroupService } from 'src/app/services/test-group.service';
import { TestService } from 'src/app/services/test.service';
import { ConfirmBoxDialog } from 'src/app/tools/ui/confirm-box/confirm-box.component';
import { ConfirmBoxModel } from 'src/app/tools/ui/confirm-box/confirm-box.model';
import { LimitBoxComponent } from 'src/app/tools/ui/limit-box/limit-box.component';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { StringConverter } from 'src/app/tools/ui/string-converter';
import { TestAvailableForProductBoxComponent } from 'src/app/tools/ui/test-available-for-product-box/test-available-for-product-box.component';
import { TestGroupBoxComponent } from 'src/app/tools/ui/test-group-box/test-group-box.component';
import { TestGroupSelectorBoxComponent } from 'src/app/tools/ui/test-group-selector-box/test-group-selector-box.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { PreventDoubleClickDirective } from '../../tools/directive/prevent-double-click.directive';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-limit-settings',
    templateUrl: './limit-settings.component.html',
    styleUrl: './limit-settings.component.scss',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [MatButtonModule, PreventDoubleClickDirective, MatIconModule, MatTooltipModule, MatDividerModule]
})
export class LimitSettingsComponent {
    Configuration?: Configuration
    TestGroupList: TestGroup[] = [];
    ProductGroupCode: string = ''
    ProductGroup?: ProductGroup
    selection = new SelectionModel<Test>(true, []);

    get HasDefault() {
        return this.TestGroupList.find(x => x.IsDefault)
    }
    
    constructor(
        private route: ActivatedRoute,
        private productGroupService: ProductGroupService,
        private testGroupService: TestGroupService,
        private testService: TestService,
        private limitService: LimitService,
        private configurationService: ConfigurationService,
        private router: Router,
        private snackBar: MatSnackBar,
        private dialog: MatDialog) {

        if (this.route.snapshot.params['productGroupCode']) {
            this.ProductGroupCode = this.route.snapshot.params['productGroupCode'];
        }
        if (this.route.snapshot.params['configurationCode']) {
            this.getConfiguration(this.route.snapshot.params['configurationCode']);
        }

        // this.getAllMyConfigurationsMock();
        this.getAllMyConfigurations();
    }

    getConfiguration(code: string) {
        this.configurationService.getConfigurationByCode(code).subscribe(x => {
            this.Configuration = x;
        })
    }

    getProductGroup() {
        this.productGroupService.getProductGroupByCode(this.ProductGroupCode).subscribe(x => {
            if (x) {
                this.ProductGroup = x;
            }
        })
    }

    saveTestGroupPositions() {
        this.testGroupService.updatePosition(this.ProductGroupCode, this.TestGroupList).subscribe(x => {
            if (x) {
                NotificationManager.handleSuccess('Ordre modifié !', this.snackBar);
            }
        });
    }

    saveTestPositions(testGroup: TestGroup) {
        this.testService.updatePosition(testGroup.Code!, testGroup.TestList).subscribe(x => {
            if (x) {
                NotificationManager.handleSuccess('Ordre modifié !', this.snackBar);
            }
        });
    }

    getComparaisonLQLabel(lq: EComparaisonLQ) {
        return StringConverter.getComparaisonLQName(lq)
    }

    getLimitValueTypeLabel(type: ELimitValueType) {
        return StringConverter.getLimitValueTypeName(type)
    }

    getELIMSTestLabel(test: Test) {
        return test.ElimsTestList.map(x => { return x.TestCode + ' ' + x.TestName }).join('\n');
    }

    getAllMyConfigurationsMock() {
        let newconf1 = new Configuration({ Code: 'conf00001', Name: 'Export Macro Sol Arcadis' });
        newconf1.ProductGroupList.push(...[
            new ProductGroup({ Code: 'code1', Name: 'name1', TestGroupList: [] }),
            new ProductGroup({ Code: 'code2', Name: 'name2', TestGroupList: [] })])
        newconf1.LimitCategoryList.push(...[
            new LimitCategory({ Name: 'ISDI' }),
            new LimitCategory({ Name: 'ISDND' }),
            new LimitCategory({ Name: 'ISDD' })])

        this.Configuration = newconf1;

        let testGroup1 = new TestGroup({ Code: 'GR00001', Name: 'Métaux et métalloïdes', IsDefault: true, IsHidden: false });
        testGroup1.TestList.push(...[
            new Test({
                Code: 'TestCode1', Name: 'Antimoine (Sb)', DisplayedUnitName: 'mg/kg MS', ElimsUnitName: 'mg/kg MS', LimitList: [
                    new Limit({ Name: newconf1.LimitCategoryList[0].Name, Value1: 2, Type1: ELimitValueType.Superieur, Value2: 5, Type2: ELimitValueType.Inferieur }),
                    new Limit({ Name: newconf1.LimitCategoryList[1].Name, Value1: 3, Type1: ELimitValueType.Superieur, Value2: 8, Type2: ELimitValueType.Inferieur })
                ]
            }),
            new Test({ Code: 'TestCode2', Name: 'Arsenic (As)', DisplayedUnitName: 'mg/kg MS', ElimsUnitName: 'mg/kg MS', LimitList: [] }),
            new Test({
                Code: 'TestCode22', Name: 'Chrome VI (CrVI)', DisplayedUnitName: 'mg/kg MS', ElimsUnitName: 'mg/kg MS', LimitList: [
                    new Limit({ Name: newconf1.LimitCategoryList[0].Name, Value1: 1, Type1: ELimitValueType.Superieur, Value2: 15, Type2: ELimitValueType.Inferieur }),
                ]
            })])
        this.TestGroupList.push(testGroup1);

        let testGroup2 = new TestGroup({ Code: 'GR00001', Name: 'BTEX', IsDefault: false, IsHidden: true });
        testGroup2.TestList.push(...[
            new Test({
                Code: 'TestCode3', Name: 'Naphtalène', DisplayedUnitName: 'mg/kg MS', ElimsUnitName: 'mg/kg MS', LimitList: [
                    new Limit({ Name: newconf1.LimitCategoryList[0].Name, Value1: 2, Type1: ELimitValueType.Superieur, Value2: 5, Type2: ELimitValueType.Inferieur }),
                    new Limit({ Name: newconf1.LimitCategoryList[2].Name, Value1: 3, Type1: ELimitValueType.Superieur, Value2: 8, Type2: ELimitValueType.Inferieur })
                ]
            }),
            new Test({ Code: 'TestCode4', Name: 'Benzène', DisplayedUnitName: 'mg/kg MS', ElimsUnitName: 'mg/kg MS', LimitList: [] })])
        this.TestGroupList.push(testGroup2);

        let testGroup3 = new TestGroup({ Code: 'GR00001', Name: 'HAP', IsDefault: false, IsHidden: true });
        testGroup3.TestList.push(...[
            new Test({
                Code: 'TestCode5', Name: 'Fluorène', DisplayedUnitName: 'mg/kg MS', ElimsUnitName: 'mg/kg MS', LimitList: [
                    new Limit({ Name: newconf1.LimitCategoryList[0].Name, Value1: 2, Type1: ELimitValueType.Superieur, Value2: 5, Type2: ELimitValueType.Inferieur }),
                    new Limit({ Name: newconf1.LimitCategoryList[2].Name, Value1: 3, Type1: ELimitValueType.Superieur, Value2: 8, Type2: ELimitValueType.Inferieur })
                ]
            }),
            new Test({ Code: 'TestCode6', Name: 'Anthracène', DisplayedUnitName: 'mg/kg MS', ElimsUnitName: 'mg/kg MS', LimitList: [] })])
        this.TestGroupList.push(testGroup3);
        // this.FilteredConfigList = this.TestGroupList;
    }

    getAllMyConfigurations() {
        this.testGroupService.getTestGroupListByProduct(this.ProductGroupCode).subscribe(x => {
            this.TestGroupList = x;
        });
    }

    openTestGroupDialog(tg?: TestGroup) {
        const dialogRef = this.dialog.open(TestGroupBoxComponent, {
            data: {
                tg: tg ?? undefined,
                canUseIsDefault: !this.TestGroupList.some(x => x.IsDefault) || tg?.IsDefault,
                canUseIsHidden: !this.TestGroupList.some(x => x.IsHidden) || tg?.IsHidden
            },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: TestGroup) => {
            if (result) {

                if (tg) {
                    this.testGroupService.update(result).subscribe(x => {
                        if (x) {
                            this.TestGroupList[this.TestGroupList.indexOf(tg)] = result;
                            NotificationManager.handleSuccess('Groupe modifié !', this.snackBar);
                        }
                    })
                }
                else {
                    this.testGroupService.create(result, this.ProductGroupCode).subscribe(x => {
                        if (x) {
                            result.Code = x;
                            result.Position = this.TestGroupList.length + 1
                            this.TestGroupList.push(result)
                            // _.last(this.TestGroupList)!.Code = x;
                            NotificationManager.handleSuccess('Groupe ajouté !', this.snackBar);
                        }
                    })
                }
            }
        });
    }

    openTestDialog(tg: TestGroup, test?: Test) {
        if (test?.Code)
            this.router.navigate([ENavigationRoute.TestManagement, { testCode: test?.Code, productGroupCode: this.ProductGroupCode }])
        else
            this.router.navigate([ENavigationRoute.TestManagement, { testGroupCode: tg.Code, productGroupCode: this.ProductGroupCode }])
    }

    openLimitDialog(test: Test, limit?: Limit) {
        const dialogRef = this.dialog.open(LimitBoxComponent, {
            data: {
                limit: limit ?? undefined,
                categoryList: this.Configuration?.LimitCategoryList
            },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: Limit) => {
            if (result) {
                if (limit) {
                    this.limitService.update(result).subscribe(x => {
                        if (x) {
                            test.LimitList[test.LimitList.indexOf(limit)] = result;
                            NotificationManager.handleSuccess('Limite modifiée !', this.snackBar);
                        }
                    })
                } else {
                    this.limitService.create(result, test.Code).subscribe(x => {
                        if (x) {
                            test.LimitList.push(result)
                            NotificationManager.handleSuccess('Limite ajoutée !', this.snackBar);
                        }
                    });
                }
            }
        });
    }

    deleteGroup(tg: TestGroup) {
        const m: ConfirmBoxModel = new ConfirmBoxModel();
        m.QuestionTitle = 'Etes-vous sûr de vouloir supprimer ce groupe ?';
        const dialogRef = this.dialog.open(ConfirmBoxDialog, {
            data: m,
            width: '777px',
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((result: boolean) => {
            if (result) {
                this.testGroupService.delete(tg.Code!).subscribe(x => {
                    if (x) {
                        _.remove(this.TestGroupList, x => x.Code === tg.Code)
                        NotificationManager.handleSuccess('Groupe supprimé !', this.snackBar);
                    }
                });
            }
        });
    }

    deleteTest(test: Test, testGroup: TestGroup) {
        const m: ConfirmBoxModel = new ConfirmBoxModel();
        m.QuestionTitle = 'Etes-vous sûr de vouloir supprimer ces tests ?';
        const dialogRef = this.dialog.open(ConfirmBoxDialog, {
            data: m,
            width: '777px',
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((result: boolean) => {
            if (result) {
                this.testService.deleteAll(this.selection.selected).subscribe(x => {
                    if (x) {
                        _.remove(testGroup.TestList, (x) => {
                            return this.selection.selected.find(y => y.Code === x.Code)
                        })
                        NotificationManager.handleSuccess('Test supprimé !', this.snackBar);
                    }
                });
            }
        });
    }

    deleteLimit(limit: Limit, test: Test) {
        const m: ConfirmBoxModel = new ConfirmBoxModel();
        m.QuestionTitle = 'Etes-vous sûr de vouloir supprimer cette limite ?';
        const dialogRef = this.dialog.open(ConfirmBoxDialog, {
            data: m,
            width: '777px',
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((result: boolean) => {
            if (result) {
                this.limitService.delete(limit.Code).subscribe(x => {
                    if (x) {
                        _.remove(test.LimitList, x => x.Code === limit.Code)
                        NotificationManager.handleSuccess('Limite supprimée !', this.snackBar);
                    }
                });
            }
        });
    }

    openMoveDialog(tg: TestGroup) {
        const dialogRef = this.dialog.open(TestGroupSelectorBoxComponent, {
            data: {
                testGroupList: this.TestGroupList
            },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: string) => {
            if (result) {

                this.testService.changeTestToNewGroup(this.selection.selected.map(x => x.Code), result).subscribe(x => {
                    if (x) {
                        // test.LimitList[test.LimitList.indexOf(limit)] = result;
                        this.selection.selected.forEach(selected => {
                            _.remove(tg.TestList, x => x.Code === selected.Code)
                            this.TestGroupList.find(x => x.Code === result)?.TestList.push(selected)
                            this.selection.toggle(selected)
                        })
                        NotificationManager.handleSuccess('Test(s) déplacé(s) !', this.snackBar);
                    }
                })
            }
        });
    }

    openAvailableTestDialog() {
        const dialogRef = this.dialog.open(TestAvailableForProductBoxComponent, {
            data: {
                productGroupCode: this.ProductGroupCode
            },
            width: '1000px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: Test[]) => {
            if (result) {

                let tgDefault = this.TestGroupList.find(x => x.IsDefault) ?? new TestGroup()
                tgDefault.TestList.push(...result)
                if (tgDefault.Code) {

                    this.testGroupService.update(tgDefault).subscribe(x => {
                        if (x) {
                            this.TestGroupList[this.TestGroupList.indexOf(tgDefault)] = tgDefault;
                            this.refreshDefaultTestGroup(tgDefault)
                            NotificationManager.handleSuccess('Groupe modifié !', this.snackBar);
                        }
                    })
                }
                else {
                    this.testGroupService.create(tgDefault, this.ProductGroupCode).subscribe(x => {
                        if (x) {
                            tgDefault.Code = x;
                            tgDefault.Position = this.TestGroupList.length + 1
                            this.TestGroupList.push(tgDefault)
                            this.refreshDefaultTestGroup(tgDefault)
                            NotificationManager.handleSuccess('Groupe ajouté !', this.snackBar);
                        }
                    })
                }

            }
        });
    }

    refreshDefaultTestGroup(tgDefault: TestGroup) {
        this.testGroupService.getTestGroupByCode(tgDefault.Code!).subscribe(x => {
            this.TestGroupList[this.TestGroupList.indexOf(this.TestGroupList.find(x => x.IsDefault)!)] = x;
        })
    }

    swapUp(index: number) {
        let toUp = this.TestGroupList[index]!;
        let toDown = this.TestGroupList[index - 1]!;

        this.TestGroupList[index - 1] = toUp;
        this.TestGroupList[index] = toDown;

        this.saveTestGroupPositions()
    }

    swapDown(index: number) {
        let toUp = this.TestGroupList[index + 1]!;
        let toDown = this.TestGroupList[index]!;

        this.TestGroupList[index] = toUp;
        this.TestGroupList[index + 1] = toDown;

        this.saveTestGroupPositions()
    }

    swapUpTest(tg: TestGroup, index: number) {
        let toUp = tg.TestList[index]!;
        let toDown = tg.TestList[index - 1]!;

        tg.TestList[index - 1] = toUp;
        tg.TestList[index] = toDown;

        this.saveTestPositions(tg)
    }

    swapDownTest(tg: TestGroup, index: number) {
        let toUp = tg.TestList[index + 1]!;
        let toDown = tg.TestList[index]!;

        tg.TestList[index] = toUp;
        tg.TestList[index + 1] = toDown;

        this.saveTestPositions(tg)
    }

    setTestGroupVisibility(tg: TestGroup) {
        tg.IsVisible = !tg.IsVisible;
    }
}
